// extracted by mini-css-extract-plugin
export default {"labelText":"ReviewStep_labelText__lEMh-","image":"ReviewStep_image__JRqlv","imageContainer":"ReviewStep_imageContainer__oSsVp","editButton":"ReviewStep_editButton__wB+s4"};